var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectedAppsSettingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50033 3.00033C3.6719 3.00033 3.00033 3.6719 3.00033 4.50033C3.00033 5.32875 3.6719 6.00033 4.50033 6.00033C5.32875 6.00033 6.00033 5.32875 6.00033 4.50033C6.00033 3.6719 5.32875 3.00033 4.50033 3.00033ZM1.66699 4.50033C1.66699 2.93552 2.93552 1.66699 4.50033 1.66699C6.06513 1.66699 7.33366 2.93552 7.33366 4.50033C7.33366 6.06513 6.06513 7.33366 4.50033 7.33366C2.93552 7.33366 1.66699 6.06513 1.66699 4.50033Z",
    fill: "#0D0D0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5003 3.00033C10.6719 3.00033 10.0003 3.6719 10.0003 4.50033C10.0003 5.32875 10.6719 6.00033 11.5003 6.00033C12.3287 6.00033 13.0003 5.32875 13.0003 4.50033C13.0003 3.6719 12.3287 3.00033 11.5003 3.00033ZM8.66699 4.50033C8.66699 2.93552 9.93553 1.66699 11.5003 1.66699C13.0651 1.66699 14.3337 2.93552 14.3337 4.50033C14.3337 6.06513 13.0651 7.33366 11.5003 7.33366C9.93553 7.33366 8.66699 6.06513 8.66699 4.50033Z",
    fill: "#0D0D0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50033 10.0003C3.6719 10.0003 3.00033 10.6719 3.00033 11.5003C3.00033 12.3287 3.6719 13.0003 4.50033 13.0003C5.32875 13.0003 6.00033 12.3287 6.00033 11.5003C6.00033 10.6719 5.32875 10.0003 4.50033 10.0003ZM1.66699 11.5003C1.66699 9.93553 2.93552 8.66699 4.50033 8.66699C6.06513 8.66699 7.33366 9.93553 7.33366 11.5003C7.33366 13.0651 6.06513 14.3337 4.50033 14.3337C2.93552 14.3337 1.66699 13.0651 1.66699 11.5003Z",
    fill: "#0D0D0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5003 10.0003C10.6719 10.0003 10.0003 10.6719 10.0003 11.5003C10.0003 12.3287 10.6719 13.0003 11.5003 13.0003C12.3287 13.0003 13.0003 12.3287 13.0003 11.5003C13.0003 10.6719 12.3287 10.0003 11.5003 10.0003ZM8.66699 11.5003C8.66699 9.93553 9.93553 8.66699 11.5003 8.66699C13.0651 8.66699 14.3337 9.93553 14.3337 11.5003C14.3337 13.0651 13.0651 14.3337 11.5003 14.3337C9.93553 14.3337 8.66699 13.0651 8.66699 11.5003Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedAppsSettingIcon);
export default __webpack_public_path__ + "static/media/ConnectedAppsSettingIcon.4ce13df3168f6a7283da0dd91a41a0f8.svg";
export { ForwardRef as ReactComponent };